import { render, staticRenderFns } from "./HeaderOverview.vue?vue&type=template&id=0f6155c4&scoped=true&"
import script from "./HeaderOverview.vue?vue&type=script&lang=js&"
export * from "./HeaderOverview.vue?vue&type=script&lang=js&"
import style0 from "./HeaderOverview.vue?vue&type=style&index=0&id=0f6155c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6155c4",
  null
  
)

export default component.exports